import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import sentry from 'legacy/utils/sentry'

import type { SubmitSpotQuoteParams } from '../infra/SpotQuoteMapper'
import { SpotQuoteRepository } from '../infra/SpotQuoteRepository'

export type SubmitSpotQuoteFactoryDependencies = {
  spotQuoteRepository: SpotQuoteRepository
}

export function submitSpotQuoteFactory({
  spotQuoteRepository,
}: SubmitSpotQuoteFactoryDependencies) {
  return async function submit(params: SubmitSpotQuoteParams, config?: { signal?: AbortSignal }) {
    try {
      return await spotQuoteRepository.submitSpotQuote(params, config)
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not submit the spot quote', { cause: error as Error })
    }
  }
}

export function submitSpotQuote(params: SubmitSpotQuoteParams, config?: { signal?: AbortSignal }) {
  const httpClient = new HttpClient(API_URL)
  const spotQuoteRepository = new SpotQuoteRepository({ httpClient })
  const submit = submitSpotQuoteFactory({ spotQuoteRepository })

  return submit(params, config)
}
